import * as types from '../types'
import { getCity } from '@/api/model/gen'
export default {
  state: {
    cityList: [],
    city: ''
  },

  getters: {
    cityList: state => {
      return state.cityList
    },
    city: state => {
      return state.city
    }
  },
  mutations: {
    [types.CITY](state, data) {
      state.city = data
    },
    [types.CITYLIST](state, data) {
      if (data) {
        state.cityList = data
        data.forEach(function (e) {
          if (e.defFlag === 1) {
            state.city = e
          }
        }, this)
      }
    }
  },
  actions: {
    [types.CITY]({ commit }, city) {
      commit(types.CITY, city)
    },
    [types.GET_CITYLIST]({ commit, state }) {
      if (state.cityList.length <= 0) {
        getCity().then(data => {
          commit(types.CITYLIST, data)
        })
      }
    }
  }
}
